import { JobPostingServiceApi } from 'my-recruiter-app-ts-if'
import { config } from './api-config'

export const jobPostingServiceApi = new JobPostingServiceApi(config)
